import { getStoreId } from "$/hooks/use-store-information"
import catalogProductQueries from "$/lib/queries/catalog-product-queries"
import upsellQueries from "$/lib/queries/upsell-queries"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

const searchSchema = z.object({
  tab: z.enum(["articles", "upsell"]).optional(),
})

export const Route = createFileRoute("/(app)/_auth/products/")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(
        catalogProductQueries.list(storeId, { page: 1, size: 20 }),
      )
      queryClient.prefetchQuery(upsellQueries.categories())
      queryClient.prefetchQuery(upsellQueries.products(storeId))
      queryClient.prefetchQuery(upsellQueries.discount(storeId))
    }
    return {
      crumb: "alfred.pages.products.crumbs.products",
    }
  },
})
